import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { DateRange, MomentDateRange } from '@core/models';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Subject } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss'],
  imports: [
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatIconModule,
  ],
})
export class DateRangeComponent implements OnInit, OnDestroy {
  @Input('dateRange') set defaultDateRange(date: DateRange) {
    if (
      this.dateForm.get('start')?.value &&
      this.dateForm.get('end')?.value &&
      this.dateForm.get('start')?.value === date.start &&
      moment(this.dateForm.get('end')?.value).toDate().toString() ===
        moment(date.end).toDate().toString()
    ) {
      return;
    }
    this.dateForm.patchValue(date);
  }

  @Input() returnFormat = '';
  @Input() isGrayView = true;
  @Input() isEventColumn = true;
  @Input() minDate!: moment.Moment;
  @Input() endMaxDate!: moment.Moment;
  @Output() changedRange: EventEmitter<DateRange> =
    new EventEmitter<DateRange>();

  public dateForm: FormGroup = this._fb.group({
    start: '',
    end: '',
  });

  private _unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private _fb: FormBuilder) {}

  ngOnInit(): void {
    this._listenDropdownChange();
  }

  // using custom method for datepicker min, because min firing valueChange
  minFilter = (to: Date): boolean => {
    const from = new Date(this.dateForm.get('start').value);
    return !(to < from);
  };

  private _listenDropdownChange(): void {
    this.dateForm.valueChanges
      .pipe(takeUntil(this._unsubscribe$), distinctUntilChanged())
      .subscribe((dateForm: MomentDateRange) => {
        const dateFilter: DateRange = {
          start: moment(dateForm.start)
            .utc(false)
            .startOf('d')
            .format(this.returnFormat),
          end: dateForm.end || moment().utc(false),
        };
        this.changedRange.emit(dateFilter);
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
